export const NAMESPACE = 'chat';
